import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';
import ToastContainer from './components/common/Toast';
import AppLayout from './components/common/AppLayout';
import ProtectedRoute from './components/common/ProtectedRoute';
import CampaignsPage from './pages/CampaignsPage';
import CreateCampaignPage from './pages/CreateCampaignPage';
import CampaignDetailsPage from './pages/CampaignDetailsPage';
import ContactsPage from './pages/ContactsPage';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import './styles/tailwind.css';
import NotFoundPage from './pages/NotFoundPage';

const App: React.FC = () => {
  return (
    <ToastProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<ProtectedRoute><AppLayout><Dashboard /></AppLayout></ProtectedRoute>} />
              <Route path="/campaigns" element={<ProtectedRoute><AppLayout><CampaignsPage /></AppLayout></ProtectedRoute>} />
              <Route path="/campaigns/create" element={<ProtectedRoute><AppLayout><CreateCampaignPage /></AppLayout></ProtectedRoute>} />
              <Route path="/campaigns/:id" element={<ProtectedRoute><AppLayout><CampaignDetailsPage /></AppLayout></ProtectedRoute>} />
              <Route path="/campaigns/:campaignId/contacts" element={<ProtectedRoute><AppLayout><ContactsPage /></AppLayout></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AppLayout><AdminPage /></AppLayout></ProtectedRoute>} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <ToastContainer />
          </div>
        </Router>
      </AuthProvider>
    </ToastProvider>
  );
};

export default App;
